import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const TabGroupLeftVerticalNavlink = ({
  verticalPrefix,
  name,
  title,
  icon,
  show,
}) => {
  const href = "#" + verticalPrefix + "-" + name;
  const aria_controls = verticalPrefix + "-" + name;
  const id = verticalPrefix + "-" + name + "-tab";

  return (
    <a
      id={id}
      data-toggle="pill"
      href={href}
      role="tab"
      aria-controls={aria_controls}
      aria-selected={show ? "true" : "false"}
      style={{
        display: "flex",
        alignItems: "center",
        gap: "8px",
        padding: "10px 14px",
        borderRadius: "8px",
        fontWeight: 600,
        fontSize: "0.88rem",
        textDecoration: "none",
        cursor: "pointer",
        transition: "background 0.15s, color 0.15s",
        background: show ? "#e8f0fe" : "transparent",
        color: show ? "#1a73e8" : "#616161",
        border: "none",
      }}
      className={show ? "nav-link active" : "nav-link"}
    >
      {icon && <FontAwesomeIcon icon={icon} style={{ fontSize: "0.9rem" }} />}
      {title}
    </a>
  );
};

export default TabGroupLeftVerticalNavlink;
